import { isFeatureEnabled } from 'owa-feature-flags';
import getStore from '../store';
import getProjects from './getProjects';

export default function isEmptyProjects() {
    return (
        getStore().projects.size == 0 ||
        getProjects().length === 0 ||
        isFeatureEnabled('cal-board-dev-forceNoProjects')
    );
}
